export default "__VITE_ASSET__CxxMqelA__"